import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import { CAESARS, WILLIAM_HILL, GENERIC } from '@williamhill/rosi-ui-shared/src/themes';
import App from './app';
import GlobalStyle from '@williamhill/rosi-ui-shared/src/global-style';
import { ModalContextProvider } from './use-modal';
import { TicketSearchContextProvider } from './manual-entry/use-ticket-search-context';
import { createBrowserHistory } from 'history';
import config from './config';
import { ServicesProviderContext } from './services';
import { BetsContextProvider } from './bets/use-bets-context';
import { CaptchaRoot } from './aws-waf-captcha/captcha-root';
import { AwsScriptProvider } from './aws-waf-captcha';

const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);
const history = createBrowserHistory({ basename: config.basePath });
const theme = (() => {
  switch (config.BRANDING) {
    case 'WILLIAM_HILL':
      return WILLIAM_HILL;

    case 'CAESARS':
      return CAESARS;

    case 'GENERIC':
    default:
      return GENERIC;
  }
})();
const { waf_url: wafUrl, captcha_url: captchaUrl, domain_list: domainList } = config.AWS;

root.render(
  <AwsScriptProvider urls={[wafUrl, captchaUrl]} domainList={domainList}>
    <ThemeProvider {...{ theme }}>
      <>
        <GlobalStyle backgroundColor={theme.colors.white} isMobile />
        <ServicesProviderContext>
          <ModalContextProvider>
            <TicketSearchContextProvider>
              <BetsContextProvider>
                <CaptchaRoot id="captcha-root" />
                <App history={history} />
              </BetsContextProvider>
            </TicketSearchContextProvider>
          </ModalContextProvider>
        </ServicesProviderContext>
      </>
    </ThemeProvider>
  </AwsScriptProvider>
);
